document.addEventListener("DOMContentLoaded", function (event) {
  if (window.innerWidth < 1025) {
    var swiper = new Swiper(".block_tab-collection-1 .block_mobproduct_full", {
      slidesPerView: 1,
      grid: {
        rows: 3,
      },
      observer: true,
      observeParents: true,
      freeMode: {
        enabled: true,
        momentumBounce: false,
      },
      navigation: {
        nextEl: ".block_tab-collection-1 .block_slider-right-arrow",
        prevEl: ".block_tab-collection-1 .block_slider-left-arrow ",
      },
      scrollbar: {
        el: ".block_tab-collection-1 .swiper-scrollbar",
        draggable: true,
        hide: false,
      },
      mousewheel: {
        forceToAxis: true,
      },
    });

    var swiper = new Swiper(".block_tab-collection-1 .block_mobtab-slider", {
      slidesPerView: 4,
      spaceBetween: 20,
      observer: true,
      freeMode: {
        enabled: true,
        momentumBounce: false,
      },
      observeParents: true,
      navigation: {
        nextEl: ".block_tab-collection-1 .block_slider-right-arrow",
        prevEl: ".block_tab-collection-1 .block_slider-left-arrow ",
      },
      scrollbar: {
        el: ".block_tab-collection-1 .swiper-scrollbar",
        draggable: true,
        hide: false,
      },
      mousewheel: {
        forceToAxis: true,
      },
      breakpoints: {
        280: {
          slidesPerView: 1,
          spaceBetween: 10,
        },
        340: {
          slidesPerView: 1.5,
          spaceBetween: 10,
        },
        400: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
      },
    });

    var swiper = new Swiper(".block_tab-collection-1 .block_mobtab-slider-full", {
        slidesPerView: 4.136,
        spaceBetween: 20,
        observer: true,
          freeMode: {
          enabled: true,
          momentumBounce: false,
        },
        observeParents: true,
        navigation: {
          nextEl: ".block_tab-collection-1 .block_slider-right-arrow",
          prevEl: ".block_tab-collection-1 .block_slider-left-arrow ",
        },
        scrollbar: {
          el: ".block_tab-collection-1 .swiper-scrollbar",
          hide: false,
          draggable: true,
        },
        mousewheel: {
          forceToAxis: true,
        },
        breakpoints: {
          280: {
            slidesPerView: 1,
            spaceBetween: 10,
          },
          340: {
            slidesPerView: 1.2,
            spaceBetween: 10,
          },
          400: {
            slidesPerView: 1.4,
            spaceBetween: 10,
          },
          580: {
            slidesPerView: 2.5,
            spaceBetween: 10,
          },
        },
      }
    );
  } else {
    var swiper = new Swiper(".block_tab-collection-1 .block_product_full", {
      slidesPerView: 1,
      grid: {
        rows: 3,
      },
      navigation: {
        nextEl: ".block_tab-collection-1 .block_slider-right-arrow",
        prevEl: ".block_tab-collection-1 .block_slider-left-arrow ",
      },
      observer: true,
      observeParents: true,
      scrollbar: {
        el: ".block_tab-collection-1 .swiper-scrollbar",
        draggable: true,
      },
      mousewheel: {
        forceToAxis: true,
      },
    });

    var swiper = new Swiper(".block_tab-collection-1  .block_tab-slider", {
      slidesPerView: 4,
      spaceBetween: 20,
      observeParents: true,
      scrollbar: {
        el: ".block_tab-collection-1 .swiper-scrollbar",
        draggable: true,
      },
      mousewheel: {
        forceToAxis: true,
      },
      navigation: {
        nextEl: ".block_tab-collection-1 .block_slider-right-arrow",
        prevEl: ".block_tab-collection-1 .block_slider-left-arrow ",
      },
      breakpoints: {
        1025: {
          slidesPerView: 3,
        },
        1280: {
          slidesPerView: 4,
        },
        1440: {
          slidesPerView: 5,
        },
      },
    });

    var swiper = new Swiper(".block_tab-collection-1 .block_tab-slider-full", {
      slidesPerView: 3.136,
      spaceBetween: 20,
      observer: true,
      observeParents: true,
      scrollbar: {
        el: ".block_tab-collection-1 .swiper-scrollbar",
        draggable: true,
      },
      mousewheel: {
        forceToAxis: true,
      },
      navigation: {
        nextEl: ".block_tab-collection-1 .block_slider-right-arrow",
        prevEl: ".block_tab-collection-1 .block_slider-left-arrow ",
      },
      breakpoints: {
        1025: {
          slidesPerView: 3.8,
        },
        1280: {
          slidesPerView: 4.5,
        }
      },
    });
  }
});
